import Vue from 'vue'
import '@/plugins/vant'
import App from './App.vue'
import router from './router'
import store from './store'
import mixin from './mixin'

Vue.use(mixin)

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
